<template>
  <router-link v-if="href.search('http')!==0" :to="href">
    <slot></slot>
  </router-link>
  <a v-else :href="href">
    <slot></slot>
  </a>
</template>

<script>
export default {
  props: {
    href: {
      type: String,
      default: "/"
    }
  }
};
</script>